'use client';
import { StaticImageData } from 'next/image';
import { TeamMemberProfile } from '../TeamMemberProfile';

import {
	Real_RJ,
	Real_Dave,
	Real_Jessica,
	Real_Jennifer,
	Real_Kevin,
} from '@/public/img/profiles_real';

export interface TeamMember {
	picture: StaticImageData;
	name: string;
	jobTitle: string;
	quote: string;
	linkedIn?: string;
}

export interface LeadershipProps {
	testId?: string;
}

const Leadership = (props: LeadershipProps) => {
	const { testId = 'Leadership' } = props;

	// The data is too big to have it inside of the component
	const leadershipTeam: TeamMember[] = [
		{
			picture: Real_Jennifer,
			name: 'Jennifer',
			jobTitle: 'General Manager',
			quote:
				'"We\'re a bold new HVAC experience—combining advanced technology with trusted industry brands to deliver a digital-first approach that simplifies heating and cooling solutions for homeowners."',
			linkedIn: 'https://www.linkedin.com/in/jennifer-a-caldwell-0158205',
		},
		{
			picture: Real_RJ,
			name: 'RJ',
			jobTitle: 'Senior Product Manager',
			quote:
				'"I love tackling the HVAC problems homeowners face. It’s awesome to turn those issues into user-friendly solutions that make their lives easier."',
			linkedIn: 'https://www.linkedin.com/in/rjstidd/',
		},
		{
			picture: Real_Dave,
			name: 'Dave',
			jobTitle: 'Head of Customer Operations',
			quote:
				'"Helping homeowners save time, money, and find confidence in their HVAC decisions has been incredibly rewarding. It\'s fun making HVAC easy!"',
			linkedIn: 'https://www.linkedin.com/in/davematters/',
		},
		{
			picture: Real_Jessica,
			name: 'Jessica',
			jobTitle: 'Engineering Manager',
			quote:
				'"Never thought I was gonna help give so many of you a level up in home comfort through HVAC.com!"',
		},
		{
			picture: Real_Kevin,
			name: 'Kevin',
			jobTitle: 'HVAC Operations',
			quote:
				'"Great to see HVAC.com help so many homeowners, aligning with the core principles I practiced selling HVAC systems in the field."',
		},
	];

	return (
		<div
			data-testid={testId}
			className="hvac-container mb-16 text-center lg:mb-20"
			aria-labelledby="leadership-heading"
		>
			<h2
				id="leadership-heading"
				className="mb-3 text-3xl font-semibold tracking-tight lg:mb-4 lg:text-5xl"
			>
				Leadership Team
			</h2>

			<div
				className="mx-auto flex max-w-6xl flex-wrap justify-center gap-x-8 gap-y-10"
				role="list"
				aria-label="Leadership team members"
			>
				{leadershipTeam.map((member) => (
					<div key={member.name} className="w-full lg:w-72">
						<TeamMemberProfile {...member} />
					</div>
				))}
			</div>
		</div>
	);
};

export default Leadership;
